import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../../constants/styles';
let {
  ERROR_BACKGROUND_COLOR,
  ERROR_BORDER_COLOR,
  ERROR_TEXT_COLOR
} = constants;

let styles = {
  error: {
    width: '100%',
    backgroundColor: ERROR_BACKGROUND_COLOR,
    border: `3px solid ${ERROR_BORDER_COLOR}`,
    padding: 15,
    color: ERROR_TEXT_COLOR,
    marginTop: 15,
    boxSizing: 'border-box'
  },
  title: {
    fontWeight: 600,
    marginBottom: 8
  },
  body: {
    fontSize: '0.9em'
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/formerror/FormError.styles.js